<div class="tw-text-sm">
    <mat-tab-group
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        id="tabGroup"
        (selectedTabChange)="emitCategorySelection($event)"
        [(selectedIndex)]="tabIndex"
        tilbyGestures
        (swipeLeft)="swipeLeft()"
        (swipeRight)="swipeRight()"
        [style.--tab-font-size]="fontNameSize + 'px'"
    >
        @if(itemsFavorite) {
            <mat-tab [label]="'CASHREGISTER.SHOWCASE.FAVOURITES' | translate"></mat-tab>
        }
        @for(category of categoriesSet; track category) {
            <mat-tab [label]="category.name"></mat-tab>
        }
    </mat-tab-group>
</div>
